import { AlertTriangle, CircleAlert } from "lucide-react";
import type { TrialIssue } from "@/lib/trial-schema";

/** Shared by the JSON tab's issues panel and each floor card's own issue list. */
export function IssueRow({ issue }: { issue: TrialIssue }) {
  const isError = issue.severity === "error";
  return (
    <div
      className={`flex items-start gap-2 rounded-md border px-3 py-2 text-xs ${
        isError
          ? "border-destructive/40 bg-destructive/10 text-destructive-foreground"
          : "border-amber-500/40 bg-amber-500/10 text-amber-200"
      }`}
    >
      {isError ? (
        <CircleAlert className="h-3.5 w-3.5 mt-0.5 shrink-0 text-destructive" />
      ) : (
        <AlertTriangle className="h-3.5 w-3.5 mt-0.5 shrink-0 text-amber-400" />
      )}
      <div className="min-w-0">
        {issue.path && <div className="font-mono text-[11px] opacity-80 truncate">{issue.path}</div>}
        <div>{issue.message}</div>
      </div>
    </div>
  );
}
